var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect, _rect2, _path14, _rect3, _path15, _rect4, _rect5, _rect6, _path16, _rect7, _rect8, _rect9, _path17, _path18, _path19, _rect10, _rect11, _rect12, _path20, _path21, _path22, _rect13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1366 768",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#83ccc3;}.cls-2{fill:#fff;}.cls-3{fill:#999;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M692.19,49.57c-181.35,0-328.37,147-328.37,328.37A327.71,327.71,0,0,0,483,631.09H901.35a327.69,327.69,0,0,0,119.22-253.15C1020.57,196.58,873.55,49.57,692.19,49.57Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M510.26,680.12h14.31q4.68,0,7,2.22a8.37,8.37,0,0,1,2.33,6.33,8.56,8.56,0,0,1-2.54,6.6q-2.54,2.38-7.75,2.38h-4.71V708h-8.65ZM518.91,692H521a5.48,5.48,0,0,0,3.5-.86,2.81,2.81,0,0,0,1-2.22,3.11,3.11,0,0,0-.88-2.22,4.52,4.52,0,0,0-3.29-.92h-2.45Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M552.25,703.39h-9.78L541.11,708h-8.8l10.48-27.88h9.4L562.67,708h-9Zm-1.79-6-3.07-10-3,10Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M578.71,697.9v-5.8H592V704a27.46,27.46,0,0,1-6.76,3.55,22.92,22.92,0,0,1-7,.94,17,17,0,0,1-8.1-1.69,11.57,11.57,0,0,1-4.84-5,16.52,16.52,0,0,1-1.73-7.68,16,16,0,0,1,1.89-7.94A12.2,12.2,0,0,1,571,681a18,18,0,0,1,7.63-1.35,21.34,21.34,0,0,1,6.91.84,9,9,0,0,1,3.8,2.59,11.61,11.61,0,0,1,2.28,4.46L583.34,689a4.57,4.57,0,0,0-1.75-2.42,5.39,5.39,0,0,0-3.12-.84,5.65,5.65,0,0,0-4.52,2c-1.12,1.32-1.68,3.39-1.68,6.23,0,3,.56,5.18,1.7,6.47a6,6,0,0,0,4.74,1.94,9,9,0,0,0,2.76-.42,14.5,14.5,0,0,0,3-1.43V697.9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M597.12,680.12h23.09v6H605.76v4.43h13.4v5.69h-13.4v5.49h14.87V708H597.12Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M638.31,680.12h8l10.5,15.42V680.12H665V708h-8.12l-10.44-15.31V708h-8.1Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M669.61,694.08q0-6.83,3.8-10.63t10.6-3.81q7,0,10.72,3.74t3.77,10.47a17.07,17.07,0,0,1-1.65,8,11.67,11.67,0,0,1-4.75,4.87,15.72,15.72,0,0,1-7.75,1.74,17.85,17.85,0,0,1-7.81-1.5,11.74,11.74,0,0,1-5-4.76A15.76,15.76,0,0,1,669.61,694.08Zm8.62,0q0,4.23,1.56,6.07a6,6,0,0,0,8.57,0c1-1.21,1.52-3.37,1.52-6.49q0-3.93-1.58-5.75a5.45,5.45,0,0,0-4.31-1.82A5.26,5.26,0,0,0,679.8,688Q678.23,689.86,678.23,694.11Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M700.17,680.12h26.19V687h-8.79v21H709V687h-8.79Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M743.28,680.12h21.3v6H751.93V691h10.81v5.63H751.93V708h-8.65Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M768.14,694.08q0-6.83,3.8-10.63t10.59-3.81q7,0,10.73,3.74T797,693.85a17.2,17.2,0,0,1-1.64,8,11.76,11.76,0,0,1-4.76,4.87,15.67,15.67,0,0,1-7.75,1.74,17.84,17.84,0,0,1-7.8-1.5,11.74,11.74,0,0,1-5-4.76A15.66,15.66,0,0,1,768.14,694.08Zm8.61,0q0,4.23,1.57,6.07a6,6,0,0,0,8.57,0q1.51-1.82,1.52-6.49,0-3.93-1.59-5.75a5.43,5.43,0,0,0-4.31-1.82,5.24,5.24,0,0,0-4.18,1.85Q776.75,689.86,776.75,694.11Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M819.8,680.12h8.6v16.61a14.06,14.06,0,0,1-.77,4.66,10,10,0,0,1-2.42,3.84,9.43,9.43,0,0,1-3.45,2.31,17.37,17.37,0,0,1-6,.93,38,38,0,0,1-4.44-.28,11.73,11.73,0,0,1-4-1.13,10.07,10.07,0,0,1-2.95-2.41,8.78,8.78,0,0,1-1.84-3.21,16.75,16.75,0,0,1-.8-4.71V680.12h8.6v17a4.89,4.89,0,0,0,1.26,3.57,5.44,5.44,0,0,0,7,0,4.84,4.84,0,0,0,1.26-3.58Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M834.16,680.12h8l10.5,15.42V680.12h8.12V708H852.7l-10.44-15.31V708h-8.1Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M866.66,680.12h12.8a15.4,15.4,0,0,1,6.11,1,10,10,0,0,1,3.85,3,12.17,12.17,0,0,1,2.21,4.47,20.59,20.59,0,0,1,.68,5.4,18.93,18.93,0,0,1-1,6.93,11.47,11.47,0,0,1-2.83,4.13,9.1,9.1,0,0,1-3.88,2.21,19.9,19.9,0,0,1-5.13.77h-12.8Zm8.61,6.31v15.23h2.12a8.89,8.89,0,0,0,3.84-.6A4,4,0,0,0,883,699a13.13,13.13,0,0,0,.65-4.84q0-4.43-1.44-6.06t-4.8-1.64Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 484.56,
    y: 145.54,
    width: 416.85,
    height: 485.18
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 492.47,
    y: 150.14,
    width: 400.24,
    height: 480.95
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M893.27,631.65H491.91V149.59H893.27ZM493,630.53H892.15V150.7H493Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 616.24,
    y: 79.13,
    width: 153.48,
    height: 52.76,
    rx: 12.23
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M617.25,392.45H569.62V245.33h47.63Zm-46.52-1.11h45.4V246.44h-45.4Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 691.48,
    y: 168.46,
    width: 1.43,
    height: 323.68
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 491.68,
    y: 492.14,
    width: 401.03,
    height: 138.95
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 572.44,
    y: 249.09,
    width: 41.98,
    height: 140.26
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M819.33,392.45H771.7V245.33h47.63Zm-46.51-1.11h45.4V246.44h-45.4Z"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 774.53,
    y: 249.09,
    width: 41.98,
    height: 140.26
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 645.91,
    y: 348.2,
    width: 36.48,
    height: 89.98
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 702.65,
    y: 348.2,
    width: 36.48,
    height: 89.98
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M573.79,169H491.91V152.14h81.88ZM493,167.9h79.66V153.25H493Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M894.05,169H812.17V152.14h81.88Zm-80.76-1.12h79.65V153.25H813.29Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M733.13,169H651.25V152.14h81.88Zm-80.76-1.12H732V153.25H652.37Z"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 573.78,
    y: 150.71,
    width: 77.46,
    height: 5.11
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 733.14,
    y: 150.56,
    width: 79.03,
    height: 5.6
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 691.64,
    y: 492.14,
    width: 1.11,
    height: 138.95
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M662.87,118.14H645.2v-8l17.67-21h8.45v21.45h4.38v7.52h-4.38v6.52h-8.45Zm0-7.52v-11l-9.34,11Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M678.72,107.07q0-10,3.58-13.93t10.92-4A16.54,16.54,0,0,1,699,90a10.66,10.66,0,0,1,3.69,2.27,11.56,11.56,0,0,1,2.25,2.92,15.09,15.09,0,0,1,1.32,3.59,33.42,33.42,0,0,1,1,8.14q0,9.49-3.21,13.9T693,125.26a15.46,15.46,0,0,1-7.12-1.41,11.57,11.57,0,0,1-4.46-4.12,15.51,15.51,0,0,1-2-5.27A35.89,35.89,0,0,1,678.72,107.07Zm9.62,0c0,4.45.39,7.48,1.17,9.11a3.72,3.72,0,0,0,3.42,2.44,3.57,3.57,0,0,0,2.56-1,6.51,6.51,0,0,0,1.6-3.27,34.43,34.43,0,0,0,.51-7c0-4.63-.39-7.75-1.18-9.34a3.77,3.77,0,0,0-3.53-2.39,3.6,3.6,0,0,0-3.48,2.44C688.69,99.68,688.34,102.7,688.34,107.09Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M727.9,118.14H710.24v-8l17.66-21h8.46v21.45h4.37v7.52h-4.37v6.52H727.9Zm0-7.52v-11l-9.33,11Z"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 387.22,
    y: 629.89,
    width: 611.52,
    height: 2.41
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/NotFound.fc3d8fd40963af0b860a8608923b6823.svg";
export { ForwardRef as ReactComponent };